export default {
  category: null,
  slot: null,
  fee: null,
}
